import { Calendar } from "@/components/ui/calendar";
import { useLocale } from "@/hooks/useLocale";
import { DateTime } from "luxon";
import { DayPickerProps, PropsRange } from "react-day-picker";

type CalendarRangeProps = Omit<
  PropsRange,
  "mode" | "captionLayout" | "locale" | "classNames" | "required"
> &
  Pick<
    DayPickerProps,
    | "endMonth"
    | "startMonth"
    | "defaultMonth"
    | "modifiers"
    | "modifiersClassNames"
  >;

const rangeClassNames = {
  range_start:
    "transition-colors !bg-slate-700 [&>button]:!bg-transparent rounded-l-lg",
  range_middle: "transition-colors !bg-slate-700 [&>button]:!bg-transparent",
  range_end:
    "transition-colors !bg-slate-700 [&>button]:!bg-transparent rounded-r-lg",
};

export function CalendarRange({ endMonth, ...props }: CalendarRangeProps) {
  const locale = useLocale();

  return (
    <Calendar
      mode="range"
      captionLayout="dropdown"
      autoFocus
      locale={locale}
      endMonth={endMonth ?? DateTime.now().plus({ years: 5 }).toJSDate()}
      classNames={rangeClassNames}
      {...props}
    />
  );
}
